import { forwardRef } from "react";

import { maskitoTransform } from "@maskito/core";
import { maskitoPhoneOptionsGenerator } from "@maskito/phone";
import metadata from "libphonenumber-js/min/metadata";
import { observer } from "mobx-react";

import { BasicInput, BasicInputProps } from "../BasicInput";

const options = maskitoPhoneOptionsGenerator({
  countryIsoCode: "RU",
  metadata,
  strict: false,
});

export interface PhoneInputProps extends BasicInputProps {
  type: "phone";
}

export const PhoneInput = observer(
  forwardRef<HTMLInputElement, PhoneInputProps>(function PhoneInput(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      event.currentTarget.value = maskitoTransform(
        event.currentTarget.value,
        options
      );

      onChange?.(event);
    };

    return (
      <BasicInput
        ref={ref}
        leftIcon="call"
        onChange={handleChange}
        {...other}
      />
    );
  })
);
